<template>
  <fin-slider :value="selected - 1" :contents="contents" :card-height="278" :card-width="260"
              no-word-break @input="val => this.selected = val + 1"/>
</template>

<script>
import FinSlider from "../../../../common/Carousel/Slider"
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'finDecisionWaySelector',
  mixins: [AmplitudePush],
  components: {FinSlider},
  props: {
    value: {
      type: Number
    },
    mode: {
      type: String
    }
  },
  data() {
    return {
      selected: this.value,
      contents: [
        {
          image: require('@/assets/onboarding/step-by-step.svg'),
          text: 'Schritt für Schritt mit 6 einfachen Fragen',
          class: 'fin-step-by-step-selection'
        },
        {
          image: require('@/assets/onboarding/choose-archetype.svg'),
          text: 'Direkt zum Archetyp',
          class: 'fin-direct-archetype-selection'
        }
      ]
    }
  },
  watch: {
    value() {
      this.selected = this.value
    },
    selected() {
      const way = this.$route.fullPath.includes('finProfiler') ? 'finProfiler' : 'onboarding'
      this.pushToAmplitude({
        'event': 'fincraft_' + way + '_archetype_decisionWay',
        'step': way + (this.selected === 1 ? '_stepByStep' : '_directChoice'),
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$emit('input', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
